export const Constants = {
  ALL_COUPONS: "All Coupons",
  ALL_PRODUCTS: "All Products",
}

// feature flags
export const STORE_CONFIRMATION_REQUIRED = false // whether store confirmation is required on checkout page